import language from '@iso/config/language.config';

import englishLang from '@iso/assets/images/flag/uk.svg';
import chineseLang from '@iso/assets/images/flag/china.svg';
import spanishLang from '@iso/assets/images/flag/spain.svg';
import frenchLang from '@iso/assets/images/flag/france.svg';
import italianLang from '@iso/assets/images/flag/italy.svg';

const config = {
  defaultLanguage: language,
  options: [
    {
      languageId: 'croatian',
      locale: 'hr',
      text: 'Croatian',
    },
    {
      languageId: 'english',
      locale: 'en',
      text: 'English',
    },
    // {
    //   languageId: 'chinese',
    //   locale: 'zh',
    //   text: 'Chinese',
    // },
    // {
    //   languageId: 'spanish',
    //   locale: 'es',
    //   text: 'Spanish',
    // },
    // {
    //   languageId: 'french',
    //   locale: 'fr',
    //   text: 'French',
    // },
    // {
    //   languageId: 'italian',
    //   locale: 'it',
    //   text: 'Italian',
    // },
  ],
};

export function getCurrentLanguage(lang) {
  let selecetedLanguage = config.options[0];
  config.options.forEach(language => {
    if (language.languageId === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}
export default config;
